<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-2"><span>A DAY AT THE BANK</span></p>
<p class="blq-normal1">An organized money market has many advantages. But it is not a school of social ethics or political responsibility.</p>
<p class="rightb"><span><span>—<i>R. H. Tawney</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter004.vue?7cbfc5f6